import APIKit from "../Allapis/Apikit/apikit";

export const newsServer = async (body) => {
  const pageNo = body.pageNo ? body.pageNo : "";
  const id = body.id ? body.id : "";
  let endpoint = "";
  let res;
  try {
    if (id) {
      endpoint = `/admin/news/${id}`;
      res = await APIKit.get(endpoint);
    } else if (pageNo) {
      endpoint = `/admin/news`;
      res = await APIKit.get(endpoint, { params: { pageNo } });
    }
    return res.data;
  } catch (e) {
    return e.response ? e.response : e;
  }
};

export const uploadImageServer = async (file) => {
  const res = await APIKit.post(`/news/upload`, file, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const createNewsServer = async (values) => {
  const res = await APIKit.post(`/admin/news/`, values);
  return res.data;
};

export const updateNewsServer = async (id, values) => {
  const res = await APIKit.put(`/admin/news/${id}`, values);
  return res.data;
};

export const deleteNewsServer = async (del_id) => {
  const res = await APIKit.delete(`/admin/news/${del_id}`);
  return res.data;
};
